import { useState, useEffect } from 'react';
import { history } from 'umi';
// import { fetchStoreRankTops } from '@/pages/intelligence/services/storeRank';
import useStoreFilterExtend from '@/pages/intelligence/hooks/useStoreRankFilterExtend';
import { fetchStoreRankTops } from '../services';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { handleSingleDate2RangeRangeTimeInFilterExtend } from '@intelligence/utils/dateUtils';
import moment from 'moment';
import type { IGameType } from '@/pages/intelligence/types/common';
import type {
  IStoreRankTopFilter,
  IStoreRankTopFetchParams,
  IStoreRankTop,
  IStoreRankTopRank,
} from '@/pages/intelligence/types/storeRank';
import { onFilterConfirm as onSetFilter } from '@intelligence/components/Filter/util';
export default function useStoreRankTopCore(props: {
  entityType: IGameType;
  // 游戏id的取值字段
  gameIdKey: 'unified_id' | 'app_id';
  // 榜单卡片点击标题 跳转榜单下钻页的 路由path
  morePagePath: string;
  // 平台key映射，用于处理接口入参时，平台值的特殊映射
  platformKeysMapping?: {
    [key: string]: string;
  };
  // 页面打点配置的key
  pageLogCfgKey: string;
  // 是否操作过筛选器
  isOperate: boolean;
  // 初始化筛选器数据
  initialFilter: IStoreRankTopFilter;
  // 查询榜单的数量，console的playstation平台 是5，其余是10
  initialPageSize?: number;
}) {
  const {
    entityType,
    // 游戏id的取值字段
    gameIdKey,
    // 榜单卡片点击标题 跳转榜单下钻页的 路由path
    morePagePath,
    // 平台key映射，用于处理接口入参时，平台值的特殊映射
    platformKeysMapping,
    // 页面打点配置的key
    pageLogCfgKey,
    // 是否操作过筛选器
    isOperate,
    // 初始化筛选器数据
    initialFilter,
    // 查询榜单的数量，console的playstation平台 是5，其余是10
    initialPageSize = 10,
  } = props;
  const {
    filterExtend: filterStoreExtend,
    setDetailFilterExtend: setStoreDetailFilterExtend,
    setFilterExtend: setStoreFilterExtend,
  } = useStoreFilterExtend({});

  const [filter, setFilter] = useState<IStoreRankTopFilter>(initialFilter);

  const [isLoading, setIsLoading] = useState(true);

  const [tops, setTops] = useState<IStoreRankTop[]>([]);

  const updateTops = async (payload: IStoreRankTopFilter) => {
    try {
      setIsLoading(true);
      const storeTmp = payload?.store;
      const fetchParamsTmp: IStoreRankTopFetchParams = {
        ...payload,
        store: platformKeysMapping?.[storeTmp] ?? storeTmp,
        region_type: 'market',
        page: 1,
        page_size: initialPageSize,
        use_custom_fields: ["super_genre","major_category","mid_category","sub_category", "sensortower_genre", "sensortower_sub_genre"]
      };
      const res = await fetchStoreRankTops(entityType, fetchParamsTmp);
      const topsTmp = res?.data ?? [];
      const { granularity, start_date: startDate, end_date: endDate } = res?.req ?? {};
      // 使用传入的 payload 而不是当前 filter 状态，确保 URL filter_tag_name 解析的值能被保留
      const filterTmp: IStoreRankTopFilter = {
        ...payload,
        granularity: granularity ?? payload?.granularity,
        start_date: startDate ?? payload?.start_date ?? '',
        end_date: endDate ?? payload?.end_date ?? '',
      };
      setFilter(filterTmp);
      let dateType = 'date';
      switch (granularity) {
        case 'daily':
          dateType = 'date';
          break;
        case 'weekly':
          dateType = 'week';
          break;
        case 'monthly':
          dateType = 'month';
          break;
        default:
          dateType = 'date';
          break;
      }
      const beforeFilterExtend = {
        rangeTime: {
          type: dateType,
          value: [moment(startDate), moment(endDate)],
        },
      };

      const { apiValue } = onSetFilter(beforeFilterExtend);
      setStoreFilterExtend(apiValue);
      setTops(topsTmp);
    } catch (exception) {
      setTops([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterConfirm = (payload: Partial<IStoreRankTopFilter>) => {
    const filterTmp: IStoreRankTopFilter = {
      ...filter,
      ...payload,
    };
    setFilter(filterTmp);
    updateTops(filterTmp);
  };

  const handleFilterReset = () => {};

  const handleGoToStoreRankMore = (payload: IStoreRankTop) => {
    if (!morePagePath) return;
    const source = payload?.name ?? '';
    // const granularity = initialFilter?.granularity ?? ''
    const { granularity, start_date: startDate, end_date: endDate } = initialFilter;
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('source', encodeURIComponent(source));
    urlSearchParams.append('granularity', encodeURIComponent(granularity));
    urlSearchParams.append('start_date', encodeURIComponent(startDate));
    urlSearchParams.append('end_date', encodeURIComponent(endDate));
    history.push({
      pathname: morePagePath,
      search: urlSearchParams.toString(),
      state: { noMatch: true }, // 保持导航栏高亮在上一级菜单
    });
  };

  const getDetailGamePath = (topPayload: IStoreRankTop, topRankPayload: IStoreRankTopRank, isValidGameId: boolean) => {
    const gameId = topRankPayload?.[gameIdKey];
    if (!isValidGameId) return '';
    const pathname = getDetailGamePathCommon({
      entityType,
      gameId,
      tab: 'storeRank',
      subTab: '',
    });
    const searchParams = new URLSearchParams();
    searchParams.set('source', encodeURIComponent(topPayload?.name));
    sessionStorage.setItem('isFromRank', 'true');
    return `${pathname}?${searchParams.toString()}`;
  };

  const handleCardGameClick = (topPayload: IStoreRankTop, topRankPayload: IStoreRankTopRank, isValidGameId: boolean) => {
    if (!isValidGameId) return;
    if (isOperate) {
      const filterExtendTmp = handleSingleDate2RangeRangeTimeInFilterExtend(filterStoreExtend);
      setStoreDetailFilterExtend(filterExtendTmp);
    }
    history.push(getDetailGamePath(topPayload, topRankPayload, isValidGameId));
  };

  const pageLog = () => {
    const pageLogInfo = dbiPageLogMes?.[pageLogCfgKey];
    if (pageLogInfo) {
      buriedPointPage(pageLogInfo);
    }
  };

  useEffect(() => {
    pageLog();
  }, []);

  return {
    // 榜单数据加载状态
    isLoading,
    // 榜单数据
    tops,
    // 筛选器数据
    filter,
    // 页面初始化时，需要自行调用该方法，查询数据，因为有的页面 不用等筛选器数据接口返回 校验 继承的筛选器值，有的页面 又需要校验，所以通用hooks内 不做这个业务判断，再页面自行决定 什么时候初始化查询数据
    onPageInit: updateTops,
    // 筛选器confirm的回调
    onFilterConfirm: handleFilterConfirm,
    // 筛选器reset的回调
    onFilterReset: handleFilterReset,
    // 榜单卡片点击游戏的回调
    onCardGameClick: handleCardGameClick,
    // 榜单卡片点击标题的回调
    onGoToStoreRankMore: handleGoToStoreRankMore,
    getDetailGamePath,
  };
}
